import React,{Component} from 'react';
import './powered.css';

class Powered extends Component{
    render(){
        return(
        <div id="powered-root">
          <div className="container">
          <h3>We're powered by our partners:</h3>
          <div className="logo-wrapper">
            <img src={require('./../../images/powered/MongoDB.png')} alt="MongoDB"/>
            <img src={require('./../../images/powered/GoogleCloud.png')} alt="Google Cloud"/>
            <img src={require('./../../images/powered/Segment.svg')} alt="Segment"/>
          </div>
          </div>
        </div>
        )
    }
}
export default Powered;


// WEBPACK FOOTER //
// ./src/components/Powered/index.js